import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import {fetchCountryList, fetchStateList, fetchCityList, fetchProfileIDList, fetchProfileProfessionList } from "../../actions/commonAction";
import { reviewmembershipRequest } from "../../actions/loginAction";
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import pathList from "../../helpers/pathList";
import { getlanguagelist } from "../../helpers/changelanguage";
import { getPublicIP } from "../../helpers/authHelper";
import AutoComplete   from "../Common/countryDropdown";
import StateDropdown   from "../Common/stateDropdown";
import CityDropdown from "../Common/cityDropdown";
import IdtypeDropdown from "../Common/idtypeDropdown";
import ProfessionDropdown from "../Common/professionDropdown";
import {validatesignupInput} from "../Validations/Signin";
import Modal from "react-responsive-modal";
import "./review.css"
import $ from 'jquery';





class Review extends Component {
  constructor(props){
    super(props);
    this.state = {
      first_name            : '',
      last_name             : '',
      title                 : '',
      gender                : '',
      phone                 : '',
      password              : '',
      countryList           : [],
      stateList             : [],
      cityList              : [],
      country_code          : '',
      country_name          : '',
      country_id            : '',
      country_dial_code     : '00',
      country_flag_code     : '',
      country               : '',
      is_country_change     : 0,
      state                 : '',
      state_name            : '',
      city                  : '',
      city_name             : '',
      zipcode               : '',
      residence_address     : '',
      email                 : '',
      id_type               : '',
      id_type_name          : '',
      id_number             : '',
      idList                : [],
      professionList        : [],
      work_title            : '',
      work_title_id         : '',
      work                  : '',
      otpmodal              : false,
      membership            : (window.location.href.includes('gold') == true) ?  'GOLD' : 'BASIC',
      user_id               : null,
      modal                 : false,
      cause                 : '',
    };
    this.onSubmit          = this.onSubmit.bind(this);
    this.handleChange      = this.handleChange.bind(this);
    this.fetchCountry      = this.fetchCountry.bind(this);
    this.fetchState        = this.fetchState.bind(this);
    this.fetchCity         = this.fetchCity.bind(this);
    this.changeCountry     = this.changeCountry.bind(this);
    this.changeState       = this.changeState.bind(this);
    this.changeCity        = this.changeCity.bind(this);
    this.fetchId           = this.fetchId.bind(this);
    this.fetchProfession   = this.fetchProfession.bind(this);
    this.changeId          = this.changeId.bind(this);
    this.changeProfession  = this.changeProfession.bind(this);
    this.closeModal        = this.closeModal.bind(this);
    this.openModal         = this.openModal.bind(this);
  }
  componentDidMount() {
    this.fetchCountry();
    this.fetchProfession();
    let modalstatus = JSON.parse(localStorage.getItem('modalstatus'));
    this.fetchId(modalstatus.country_code);
    
  }
  fetchCountry(){
    this.props.fetchCountryList();
  }
  fetchState(countryId){
    this.props.fetchStateList(countryId);
  }
  fetchCity(stateId){
    this.props.fetchCityList(stateId);
  }
  fetchId(countryId){
    this.props.fetchProfileIDList(countryId);
  }
  fetchProfession(){
    this.props.fetchProfileProfessionList();
  }

  changeCountry(countryData){
    this.setState({
       country_code          :  countryData.country_code,
       country               :  countryData.country_code,
       country_name          :  countryData.country_name,
       country_id            :  countryData.country_id,
       country_dial_code     :  countryData.country_dial_code,
       country_flag_code     :  countryData.country_flag_code,
       is_country_change     :  1,
       state                 :  '',
       state_name            :  '',
       city                  :  '',
       city_name             :  '',
       zipcode               :  '',
     }) ;
     this.fetchState(countryData.country_code); 
     this.fetchId(countryData.country_code);
    
  }

  changeState(stateData){
    this.setState({
      is_country_change     :  1,
      state                 :  stateData.id,
      state_name            :  stateData.name,
      city                  :  '',
      city_name             :  '',
      zipcode               :  '',
     })  
    this.fetchCity(stateData.id);
  }

  changeCity(cityData){
    this.setState({
      is_country_change     :  1,
      city                  :  cityData.id,
      city_name             :  cityData.name,
      zipcode               :  '',
    })  
  }
  changeId(idData){
    this.setState({
      id_type          : idData.id_type_id,
      id_type_name     : idData.id_type,
      id_number        : '',
    }) 
  }

 changeProfession(professionData){
  this.setState({
      work_title            : professionData.work_title,
      work_title_id         : professionData.work_title_id,
      work                  : ''
  })
   
 }
  onSubmit(e){
    e.preventDefault();
    let param = {};
    let rejection   = JSON.parse(localStorage.getItem('rejectedstatus'));
    let modalstatus = JSON.parse(localStorage.getItem('modalstatus'));
    rejection.map((field,index) => {
      Object.assign(param, {
        [`${field.field_id}`]: this.state[field.field_id]
      })
    })
    Object.assign(param, {
      user_id: modalstatus.id
    })
    console.log(param);
    //this.props.reviewmembershipRequest(param);
    let { error, isValid } = validatesignupInput(param);
    if (isValid) {
      this.props.reviewmembershipRequest(param);
    }else{
      ToastsStore.error(error.message);
    } 
  } 
  
 


  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps,prevProps){
    if((nextProps.countryList != null) || (this.state.is_country_change == 1)){
      this.setState({
          countryList : nextProps.countryList
      })
    }
    if((nextProps.stateList != null) || (this.state.is_country_change == 1)){
      this.setState({
          stateList : nextProps.stateList
      })
    }
    if((nextProps.cityList != null) || (this.state.is_country_change == 1)){
      this.setState({
          cityList : nextProps.cityList
      })
    }
        
    if(nextProps.idList != null){
      this.setState({
          idList : nextProps.idList
      })
    }
    if(nextProps.professionList != null){
        this.setState({
            professionList : nextProps.professionList
        })
    }

    if(nextProps.review != this.props.review){
      window.location.reload();
        /* let curlang = (localStorage.getItem('userLanguage') == undefined) ? 'so' : 'en';
        if(curlang == 'en'){
          $("#thanku").html('<h2>Thank You</h2><span>for your submission.</span><div class="clr25"></div><p>Your account is pending for approval from <br/>Administrator. We hope to see you soon with us.</p>');
          $("#thank_btn").html('Close');
        }else{
          $("#thanku").html('<h2>Waad ku</h2><span>mahadsan tahay soo gudbintaada.</span><div class="clr25"></div><p>Dalabkaaga wuxuu ansixin ka sugayaa maamulka <br/>BD. Waxaan kuu rajeyneynaa in si deg deg ah laguugu aqbalo.</p>');
          $("#thank_btn").html('Xir');
        }
        $("#myModal").modal() */
    }
  }
  closeModal(){
    this.setState({
      modal : false,
      
    })
  }
  openModal(cause){
    this.setState({
      modal : true,
      cause : cause
    })
  }
  render() {
    let  languagelist = getlanguagelist();
    let rejection = localStorage.getItem('rejectedstatus') != undefined ? JSON.parse(localStorage.getItem('rejectedstatus')) : [];
    let fields = new Array();
    rejection.map((field,index) => {
        fields[field.field_id] = field.reject_reason;
    })
    return (
      <div className="container">
          <div className="row">
            <div className="col-lg-7">&nbsp;
              <a href="/" className="login_logo">
                  <img width="100px" src="/static/logi_logo-46f18e7afcfaf1324f5d.png" />
              </a>
            </div>
        <div className="col-lg-5">
        <div className="login_reg_box">
             <div className="login_box" >
                <p className="review-heading" > 
                {languagelist.txt_information_for_reject}
                </p>
              </div>
            
            <form id="signup-form" onSubmit={this.onSubmit}>
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground />
            <div className="reg_box">
                { fields["first_name"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_user.png" />
                        <input type="text" placeholder={languagelist.fname} name="first_name" value={this.state.first_name} onChange={this.handleChange} required/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["first_name"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                : null
                }
                { fields["last_name"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_user.png" />
                        <input type="text" placeholder={languagelist.lname} name="last_name" value={this.state.last_name} onChange={this.handleChange}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["last_name"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                : null
                }

                { fields["title"] !== undefined  ?
                    <div className="input-icon">
                      <img className="icon" src="/assets/images/r_user.png" />
                      <select className="form-control" name="title" value={this.state.title} onChange={this.handleChange} required>
                        <option value="" >{languagelist.title}</option>
                        <option value="Mr." >{languagelist.mr}</option>
                        <option value="Ms." >{languagelist.ms}</option>
                        <option value="Mrs." >{languagelist.mrs}</option>
                        <option value="Dr." >{languagelist.dr}</option>
                        <option value="Prof." >{languagelist.prof}</option>
                    </select>
                    <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["title"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div> 
                    : null
                }  
                { fields["gender"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_gender.png" />
                        {/* <input type="text" placeholder="Gender" /> */}
                        <select className="form-control" name="gender" value={this.state.gender} onChange={this.handleChange} required>
                            <option value="" >{languagelist.gender}</option>
                            <option value="F" >{languagelist.female}</option>
                            <option value="M" >{languagelist.male}</option>
                            <option value="T" >{languagelist.otherg}</option>
                        </select>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["gender"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                 : null
                }  
                { fields["residence_address"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_address.png" />
                        <input type="text" placeholder={languagelist.address} name="residence_address" value={this.state.residence_address} onChange={this.handleChange}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["residence_address"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["country_name"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_cuntry.png" />
                        {/* <input type="text" placeholder="Country" /> */}
                        <AutoComplete dataList={this.state.countryList} defaultVal = {this.state.country_name} changeCountry={this.changeCountry}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["country_name"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["state"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_state.png" />
                        {/*  <input type="text" placeholder="Region / Province / State" /> */}
                        <StateDropdown dataList={this.state.stateList} defaultVal = {this.state.state_name} changeState={this.changeState}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["state"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["city"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_city.png" />
                        {/*  <input type="text" placeholder="City" /> */}
                        <CityDropdown dataList={this.state.cityList} defaultVal = {this.state.city_name} changeCity={this.changeCity}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["city"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["zipcode"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_zip.png" />
                        <input type="text" placeholder={languagelist.zip} maxLength="15" name="zipcode" value={this.state.zipcode} onChange={this.handleChange}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["zipcode"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["id_type"] !== undefined  ?
                   
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_id.png" />
                        <IdtypeDropdown dataList={this.state.idList} defaultVal = {this.state.id_type_name} changeId={this.changeId}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["id_type"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                 : null
                }  
                { fields["id_number"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_id.png" />
                        <input type="text" placeholder={languagelist.idcardd} name="id_number" value={this.state.id_number} onChange={this.handleChange} required/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["id_number"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                  : null
                }  
                { fields["career"] !== undefined  ?
                    <div className="input-icon">
                      <img className="icon" src="/assets/images/r_career.png" />
                      <input type="text" placeholder={languagelist.career} name="career" value={this.state.career} onChange={this.handleChange} required/>
                      <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["career"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                    : null
                }  
                { fields["work_title"] !== undefined  ?
                    <div className="input-icon">
                        <img className="icon" src="/assets/images/r_work_position.png" />
                        <ProfessionDropdown dataList={this.state.professionList} defaultVal = {this.state.work_title} changeProfession={this.changeProfession}/>
                        <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["work_title"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                    </div>
                 : null
                }  
                { fields["work"] !== undefined  ?
                  <div className="input-icon">
                      <img className="icon" src="/assets/images/r_work_position.png" />
                      <input type="text" placeholder={languagelist.wposition} name="work" value={this.state.work} onChange={this.handleChange} required/>
                      <a href={void(0)} className="input_info" onClick={()=>this.openModal(fields["work"])}><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                  </div>
                 : null
                } 
                <div className="text-center">
                    <button className="user_login_btn" type="submit">{languagelist.save}</button>
                   
                </div>
            </div>
               
            
            </form>       
       
            </div>
       
    </div>
    </div>
    
        <Modal open={this.state.modal} onClose={this.closeModal} showCloseIcon={false} center>
          <div className="modal-header2">
           
            <button type="button" className="close" onClick={this.closeModal} ><img src="/assets/images/close_btn.png"/></button>
            
          </div>
          <div className="modal-body">
          
              <div className="row">
                  <h4></h4>
                  <p>{this.state.cause}</p>
              </div>
          </div>
      </Modal>
    </div>
    );
  }
}

const mapStateToProps = state => {
return {
      countryList         : state.countrylist.countryList,
      stateList           : state.statelist.stateList,
      cityList            : state.citylist.cityList,
      idList              : state.idlist.idList,
      professionList      : state.professionlist.professionList, 
      review              : state.reviewmembership.reviewMembership
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      fetchCountryList           : bindActionCreators(fetchCountryList, dispatch),
      fetchStateList             : bindActionCreators(fetchStateList, dispatch),
      fetchCityList              : bindActionCreators(fetchCityList, dispatch),
      fetchProfileIDList         : bindActionCreators(fetchProfileIDList, dispatch), 
      fetchProfileProfessionList : bindActionCreators(fetchProfileProfessionList, dispatch),
      reviewmembershipRequest    : bindActionCreators(reviewmembershipRequest, dispatch),
      
    }
  }
  /* 
  RegistrationForm.propTypes = {
    createLoginRequest: PropTypes.func.isRequired,
  }; */
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Review);
